import useCancelRegistry from '../Hooks/UseCancelRegistry';
import { useMemo } from 'react';
import EntityService from './EntityService';
import LocalStorage from './Persistence/LocalStorage';
import useAuthenticatedFetchClient from '../Hooks/UseAuthenticatedFetchClient';
import useAuthenticatedGqlClient from '../Hooks/UseAuthenticatedGqlClient';
import { GetOrganisationDocument, GetOrganisationsDocument, } from '../Graphql/__generated__/graphql';
const CURRENT_ORG_ID_STORAGE_KEY = 'organisationId';
export default class OrganisationService extends EntityService {
    temporaryStorage;
    entityName = 'Organisation';
    constructor(gqlClient, fetchClient, registerCancel) {
        super(gqlClient, fetchClient, registerCancel);
        this.temporaryStorage = new LocalStorage();
    }
    getOrganisation(id) {
        return this.graphqlQuery({
            query: GetOrganisationDocument,
            variables: { id },
        });
    }
    getOrganisations(maxItems = 10, searchTerm) {
        return this.graphqlQuery({
            query: GetOrganisationsDocument,
            variables: { nameLike: `%${searchTerm ?? ''}%`, maxItems },
        });
    }
    async getOrganisationIdFromLocalStorage() {
        return await this.temporaryStorage.getItem(CURRENT_ORG_ID_STORAGE_KEY);
    }
    async saveOrganisationIdIntoLocalStorage(id) {
        return await this.temporaryStorage.setItem(CURRENT_ORG_ID_STORAGE_KEY, id);
    }
}
export function useOrganisationService() {
    const gqlClient = useAuthenticatedGqlClient();
    const fetchClient = useAuthenticatedFetchClient();
    const registerCancel = useCancelRegistry();
    return useMemo(() => new OrganisationService(gqlClient, fetchClient, registerCancel), [gqlClient, fetchClient, registerCancel]);
}
//# sourceMappingURL=OrganisationService.js.map